
import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Organization, User } from 'src/app/models';
import { UserService, AppService, OrganizationService, TrainingPlanService, CardioProgramService, TranslateConfigService } from 'src/app/services';
import * as Sentry from "@sentry/angular-ivy";
import { WorkoutProgram } from 'src/app/models/training/workout-program.model';

@Component({
  selector: 'app-workout-select',
  templateUrl: './workout-select.component.html',
  styleUrls: ['./workout-select.component.scss'],
})
export class WorkoutSelectComponent implements OnInit {

  public activeOrganization: Organization;
  public activeUser: User;
  public workoutPrograms: WorkoutProgram[];
  public filteredWorkoutPrograms: WorkoutProgram[];
  public searchTerm: string = "";

  @Input() userId: string;
  @Input() type: "cardio" | "workout" = "workout";
  @Input() source: "organization" | "user" = "user";

  constructor(private cardioProgramService: CardioProgramService,
    private modalCtrl: ModalController,
    private userService: UserService,
    private appService: AppService,
    private trainingPlanService: TrainingPlanService,
    private organizationService: OrganizationService,
    private translateConfig: TranslateConfigService
  ) { }

  ngOnInit() { }

  async ionViewDidEnter() {
    this.activeOrganization = this.organizationService.getAppOrganization();
    this.activeUser = await this.userService.getUserAsPromise(this.userId);
    this.loadMealPlans();
  }

  async loadMealPlans() {
    if (this.appService.isOnline) {
      await this.appService.presentLoading();
      try {
        let allPrograms;
        if(this.type === "cardio") {
          allPrograms = await this.cardioProgramService.getPublishedCardioPrograms(this.activeUser.uid);
        } else {
          if(this.source === "organization") {
            allPrograms = await this.trainingPlanService.getOrganizationWorkoutsAsPromise(this.activeOrganization.uid)
          } else {
            allPrograms = await this.trainingPlanService.getActiveWorkoutPrograms(this.activeUser.uid)
          }
        }
        const programs = [];
        if (allPrograms && allPrograms.length > 0) {
          for (const program of allPrograms) {
            if (this.activeUser.getOrganizationStatus(program.organization) !== "disabled") {
              
              if(this.source === 'user' && program.createdBy !== this.userService.user.uid && (!program.isStartDateValid() || !program.isEndDateValid())) {
                continue
              }

              programs.push(program);
            }
          }
        }
        this.workoutPrograms = programs;
        this.filteredWorkoutPrograms = programs;
      } catch (error) {
        Sentry.captureException(error.originalError || error);
        this.appService.showToastWithDuration(this.translateConfig.t('general.unexpectedError'))
      } finally {
        setTimeout(() => {
          this.appService.hideLoading();
        }, 50);
      }
    } else {
      this.appService.showToastWithDuration(this.translateConfig.t('general.pleaseConnectToInternet'));
    }
  }

  cancel() {
    this.modalCtrl.dismiss()
  }

  selectWorkout(program: WorkoutProgram, index: number) {
    this.modalCtrl.dismiss({program: program, workoutIndex: index}, "selected");
  }

  selectOrgWorkout(workout) {
    this.modalCtrl.dismiss({workout: workout}, "selected");
  }

  filterWorkouts() {
    if (!this.searchTerm || this.searchTerm.trim() === "") {
      this.filteredWorkoutPrograms = this.workoutPrograms;
      return;
    }

    const searchLower = this.searchTerm.toLowerCase().trim();
    this.filteredWorkoutPrograms = this.workoutPrograms.filter(program => {
      return program.title?.toLowerCase().includes(searchLower);
    });
  }

  isSplitProgram(plan: Partial<WorkoutProgram> & { original?: WorkoutProgram }): boolean {
    const source: any = plan?.original || plan;
    const draftKind = source?.draftWorkoutProgram?.workoutProgramKind;
    return (source?.workoutProgramKind || draftKind) === "split";
  }
}